import React from 'react'

import { TickIcon, ShieldIcon, SignalIcon } from '~/assets/icons'

import styles from './styles.module.css'

const DealFeatures = ({
  features
}: {
  features: Array<{
    service: string
    text: string
  }>
}) => {
  const Icon = ({ text }: { text: string }) => {
    if (text === '4G back-up if your broadband goes down') return <ShieldIcon width={20} height={20} />

    if (text === 'Wi-Fi guarantee for whole home coverage') return <SignalIcon width={20} height={20} />

    return <TickIcon width={20} height={20} />
  }

  const Text = ({ text }: { text: string }) => {
    if (text === '4G back-up if your broadband goes down')
      return (
        <>
          <strong>4G back-up</strong> if your broadband goes down
        </>
      )

    if (text === 'Wi-Fi guarantee for whole home coverage')
      return (
        <>
          <strong>Wi-Fi guarantee</strong> for whole home coverage
        </>
      )

    return <>{text}</>
  }

  return (
    <div className={styles.container}>
      {features.map((feature, index) => (
        <div key={index} className={styles.item}>
          <Icon text={feature.text} />

          <div className={styles.text}>
            <Text text={feature.text} />
          </div>
        </div>
      ))}
    </div>
  )
}

export default DealFeatures
